import ConfirmDialog from 'components/ConfirmDialog/ConfirmDialog'
import { FC, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { useDispatch } from 'react-redux'
import { missionThunks } from 'store/thunks/mission'

import style from './SetOccupiedSideModal.module.css'

interface SetOccupiedSideModalProps {
  zoneId: number
  isModalOpen: boolean
  closeModal: () => void
}

const SetOccupiedSideModal: FC<SetOccupiedSideModalProps> = ({ zoneId, isModalOpen, closeModal }) => {
  const { t } = useTranslation()
  const dispatch = useDispatch<any>()
  const [side, setSide] = useState<'left' | 'right'>('left')

  const handleSubmit = async () => {
    await dispatch(missionThunks.setOccupiedSide(zoneId, side))
    closeModal()
  }

  return (
    <ConfirmDialog
      isOpen={isModalOpen}
      onClose={closeModal}
      onConfirmClick={handleSubmit}
      title={'Set Occupied Side'}
      confirmText={t('common.select')}
      cancelText={t('common.cancel')}
      overlayZIndex={1000}
    >
      <div className={style.content}>
        <div className="text-14-400">{'Select the side where the occupied zone should be created'}</div>
        <div className={style.options}>
          <label className={style.radioLabel}>
            <input type="radio" name="side" value="left" checked={side === 'left'} onChange={() => setSide('left')} />
            <span className="text-14-400">{'Left'}</span>
          </label>
          <label className={style.radioLabel}>
            <input
              type="radio"
              name="side"
              value="right"
              checked={side === 'right'}
              onChange={() => setSide('right')}
            />
            <span className="text-14-400">{'Right'}</span>
          </label>
        </div>
      </div>
    </ConfirmDialog>
  )
}

export default SetOccupiedSideModal
